import api from '@/services/api';
import StudentList from '../components/StudentList.vue';

export const getBuildingStudents = async buildingId => {
  const result = await api.get(`/students/${buildingId}`);
  return result.data;
};

export const createStudents = async payload => {
  const result = await api.post(`/students`, payload);
  return result.data;
};

export const openPort = async student => {
  const result = await api.post(`/students/open`, student);
  return result.data;
};

export const closePort = async student => {
  const result = await api.post(`/students/close`, student);
  return result.data;
};

export const closePortAll = async listStudents => {
  const result = await api.post(`/students/closeAll`, listStudents);
  return result.data;
};

export const updateStudentStatus = async StudentList => {
  const result = await api.post(`/students/updatestatus`, StudentList);
  return result.data;
}

export const deleteStudent = async studentId => {
  const result = await api.delete(`/students/${studentId}`);
  return result.data;
};
